import { connect } from 'react-redux';
import Snackbar from './Snackbar';
import { remove, clear } from '../../store/actions/snackbar';
import { selector } from '../../store/reducers/snackbar';

const mapStateToProps = (state) => (selector(state));

const mapDispatchToProps = {
  removeMessage: remove,
  removeAllMessages: clear,
};

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
